import React from 'react'
import { useTranslation } from 'react-i18next'

// A spinning arc drawn with SVG strokes. Border-based spinners are flattened into a static ring
// by the global `.finance-route-shell [class*="border-r"] { border-color: ... !important }` rule.
export const MwSpinnerIcon = ({ size = 56 }) => (
    <svg width={size} height={size} viewBox="0 0 50 50" aria-hidden="true">
        <circle cx="25" cy="25" r="20" fill="none" stroke="#e0e7ff" strokeWidth="5" />
        <g>
            <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.8s"
                repeatCount="indefinite"
            />
            <circle cx="25" cy="25" r="20" fill="none" stroke="#4f46e5" strokeWidth="5" strokeLinecap="round" strokeDasharray="90 150" />
        </g>
    </svg>
)

// A large spinner centered over a list while it (re)loads. The list keeps its rows underneath,
// so the box does not collapse and grow back on every search.
const MwLoadingOverlay = ({ label, compact = false }) => {
    const [t] = useTranslation('global');
    const text = label ?? t('common.loading', { defaultValue: 'جاري التحميل...' });
    return (
        <div
            role="status"
            aria-live="polite"
            className="absolute inset-0 z-20 flex items-start justify-center bg-white/80 dark:bg-slate-800/80"
        >
            <div className={`sticky flex flex-col items-center gap-3 ${compact ? 'top-4 pt-4' : 'top-1/3 pt-16'}`}>
                <MwSpinnerIcon size={compact ? 32 : 56} />
                {!compact && <span className="text-sm font-bold text-indigo-600">{text}</span>}
            </div>
        </div>
    )
}

export default MwLoadingOverlay


